(function () {
  "use strict";

  angular
    .module("alk.forms")
    .controller("ChangePasswordController", ChangePasswordController);

  ChangePasswordController.$inject = [
    "alkAuthenticationService",
    "Messages",
    "ALKChangePassword",
    "$translate",
    "$uibModalInstance"
  ];

  function ChangePasswordController(alkAuthenticationService, Messages, ALKChangePassword, $translate, $uibModalInstance) {
    var vm = this;

    vm.isProcessing = false;
    vm.updateLogin = updateLogin;
    vm.messageToShow = "";
    vm.loginInfo = {};
    vm.cancel = cancel;

    ////////////////

    function cancel() {
      $uibModalInstance.close();
      Messages.clear();
    }

    function updateLogin() {
      vm.loginInformationForm.$setSubmitted(true);

      if (!vm.loginInformationForm.$valid) {
        return;
      }

      vm.loginInformationForm.$setPristine(false);

      vm.isProcessing = true;
      Messages.clear();

      var changePassword = new ALKChangePassword(vm.loginInfo.existingPassword, vm.loginInfo.newPassword);
      alkAuthenticationService.changePassword(changePassword)
        .then(() => {
          vm.loginInfo = {};

          Messages.add("success", $translate.instant("common.password.changeSuccess"), {
            showOnNextPage: false
          });
        }, (err) => {
          var errData = err.data;
          var message = $translate.instant("common.password.changeUnknownError");
          if (errData.reason === 1) {
            message = $translate.instant("common.password.changeFailedToLogin");
          }

          Messages.add("danger", message, {
            showOnNextPage: false
          });
        })
        .finally(function () {
          vm.messageToShow = "password";
          vm.isProcessing = false;
        });
    }
  }
})();



// WEBPACK FOOTER //
// ./Common Javascript Files/AngularJS/alk-forms/change-password/changePasswordController.js